import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { ColDef, ColumnApi, DomLayoutType, GridApi, IDetailCellRendererParams } from 'ag-grid-enterprise';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { AgGridService } from '../../../app/services/agGridService.service';
import { Subject } from 'rxjs';
import { NumbersCellRedererComponent } from '../components-ag-grid/numbers-cell-rederer/numbers-cell-rederer.component';
import { CurrencyValueCellRedererComponent } from '../components-ag-grid/currency-value-cell-rederer/currency-value-cell-rederer.component';
import { ActionsRequestSetupComponent } from '../actions-request-setup/actions-request-setup.component';
import { FilterTheClickTableComponent } from '../components-ag-grid/filter-the-click-table/filter-the-click-table.component';
import { PercentCellRendererComponent } from '../components-ag-grid/percent-cell-renderer/percent-cell-renderer.component';
import { takeUntil } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';

@Component({
  selector: 'app-table-ag-grid',
  templateUrl: './table-ag-grid.component.html',
  styleUrls: ['./table-ag-grid.component.css'],
  standalone: true,
  imports: [AgGridModule, NgClass]
})
export class TableAgGridComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() respTable?: any;
  @Input() height!: string;
  @Input() exportCsv!: boolean;
  @Input() csvToLeft!: boolean;
  @Input() showSkeleton!: boolean;
  @Input() pagination!: boolean;
  @Input()
  @Output()
  customCellClick: EventEmitter<{
    column?: string;
    value?: any;
    path?: any;
    modalName?: any;
    cellClass?: any;
    get?: any;
    actions?: any;
    data?: any;
    event?: any;
  }> = new EventEmitter();

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  contextMenuOpened: boolean = false;
  menuX = 0;
  menuY = 0;

  public tooltipShowDelay = 0;
  public tooltipHideDelay = 2000;
  public pinnedBottomRowData: any[] = [];
  private gridColumnApi!: ColumnApi;
  private gridApi!: GridApi;
  public domLayout: DomLayoutType = 'autoHeight';
  auxParams: any;
  rowData: any[] = [];
  columnDefs: any[] = [];
  headers: ColDef[] = [];
  toLeft = true;
  isPopupOpen!: boolean;
  showPopup: boolean = false;
  frameworkComponents: any;
  rowSelection = 'multiple';
  skeleton: boolean = true;

  public detailCellRendererParams: any = {
    detailGridOptions: {
      columnDefs: [
        { field: 'callId' },
        { field: 'direction' },
        { field: 'number' },
        { field: 'duration', valueFormatter: "x.toLocaleString() + 's'" },
        { field: 'switchCode' }
      ],
      defaultColDef: {
        flex: 1
      }
    },
    getDetailRowData: (params) => {
      params.successCallback(params.data.callRecords);
    }
  } as IDetailCellRendererParams<any, any>;

  excelStyles = [
    {
      id: 'stringType',
      dataType: 'String'
    }
  ];

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private agGridService: AgGridService
  ) {}

  currencyFormatter(params: any) {
    if (params.value === undefined || params.value === null) return '';
    return '$' + params?.value?.toFixed(2);
  }

  ngOnInit(): void {
    this.showSkeleton = this.showSkeleton;
    this.agGridService.triggerFunction$.pipe(takeUntil(this.destroy$)).subscribe((resp: any) => {
      this.hideColumns(resp);
    });
  }

  ngAfterViewInit(): void {
    /* if(this.respTable.rowData && Array.isArray(this.respTable.rowData) && this.respTable.rowData.length > 0) {
      this.pinnedScroll();
    } */
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$?.complete();
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.pinnedScroll();
  }

  pinnedScroll() {
    const agModal = document.querySelector('.ag-billing');
    const hasScroll = document.querySelector('.ag-body-horizontal-scroll');
    const tableMain = document.querySelector('#myTable');

    let validation = (container: any, item: any) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            const target = mutation.target as HTMLElement;
            if (target.classList.contains('ag-hidden')) {
              container.classList.remove('pinnedB');
            } else {
              container.classList.add('pinnedB');
            }
          }
        });
      });
      observer.observe(item, { attributes: true, childList: true });
    };

    if (agModal) {
      const agScroll = agModal.querySelector('.ag-body-horizontal-scroll');
      const tableModal = agModal.querySelector('#myTable');
      validation(tableModal, agScroll);
    } else {
      validation(tableMain, hasScroll);
    }
  }

  hideColumns(choice: any) {
    choice = !choice;
    this.gridColumnApi.setColumnsVisible(this.respTable.columnsToDisplay, choice);
  }

  public defaultColDef: ColDef = {
    editable: false,
    cellDataType: false,
    sortable: true,
    /*  suppressSizeToFit: true, */
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    resizable: true
    //flex: 1,
  };

  gridOptions: GridOptions = {
    /* skeleton: true, */
    /*  virtualization: true, */
    pagination: true,
    paginationPageSize: 100,
    domLayout: 'autoHeight',
    cacheBlockSize: 100,
    copyHeadersToClipboard: true,
    /* headerClass: 'custom-header', */
    onFilterChanged: this.handleFilterChanged,
    getRowHeight: () => 34,
    /* debounceMs: 0, */
    /* gridStyle: { 'border-color': '#F6F6F6' }, */
    /* getRowStyle: this.hadleRows, */
    /* valueFormatter: (params: any) => {
      const value = params.value;
      if (value == undefined || value == null || value == "") {
        return " - ";
      }
      return value;
    }, */
    context: { componentParent: this },
    onGridReady: (event: any) => event.api.sizeColumnsToFit()
    // ... outras opções ...
  };

  onSelectionChanged(event: any) {}

  hadleRows(params: any) {
    if (params.data.precedingItemNumber && params.data) {
      const currentSoItem = params.data.precedingItemNumber;

      if (params.node && params.node.rowIndex > 0) {
        const previousRowNode = params.api.getDisplayedRowAtIndex(params.node.rowIndex - 1);
        if (previousRowNode && previousRowNode.data.precedingItemNumber !== currentSoItem) {
          return {
            borderTop: '2px solid #9EC7D6'
          };
        }
      }
    }
    return null;
  }

  handleFilterChanged() {
    const skeletonElement = document.getElementById('skeleton');
    if (skeletonElement !== null) {
      skeletonElement.style.display = 'block';
    }
  }

  onGridReady(params: GridReadyEvent) {
    if (this.respTable.rowData && Array.isArray(this.respTable.rowData) && this.respTable.rowData.length > 0) {
      this.pinnedScroll();
    }

    this.onReplaceRendererButtonClick(this.respTable);
    const rootWrapper = this.el.nativeElement.querySelector('.ag-root-wrapper.ag-layout-normal');

    if (rootWrapper) {
      this.renderer.setStyle(rootWrapper, 'height', this.height);
    }

    this.toLeft = typeof this.csvToLeft === 'undefined' ? true : this.csvToLeft;
    this.rowData = this.respTable?.rowData;
    this.pinnedBottomRowData = this.respTable?.pinnedBottomRowData;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.auxParams = params;

    this.makeRowStyleAsync(this.respTable?.columnDefs)
      .then((updatedColumnDefs) => {
        setTimeout(() => {
          this.autoSizeAll();
          this.skeleton = false;
        });
      })
      .catch((error) => {
        console.error('Erro:', error);
      });
  }

  makeRowStyleAsync(columnDefs: any[]): Promise<any[]> {
    return new Promise<any[]>((resolve) => {
      /*  this.columnDefs = columnDefs.map((colDef: any) => {
         return colDef;
       }); */
      let columnNumber = 1;
      this.columnDefs = columnDefs.map((colDef: any) => {
        colDef.debounceMs = 0;
        /*   colDef.colId = `col${columnNumber}`;
          columnNumber++; */

        if (colDef.cellClass === 'currency-value') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              const stringValue = params?.value?.toString();
              const numericValue = parseFloat(stringValue?.replace(/[^\d.-]/g, ''));

              if (numericValue < 0) {
                return 'negative-dollar';
              } else if (numericValue > 0) {
                return 'positive-dollar';
              }

              return '';
            },
            valueFormatter: (params: any) => {
              const stringValue = params?.value?.toString();
              const numericValue = parseFloat(stringValue?.replace(/[^\d.-]/g, ''));

              if (isNaN(numericValue)) {
                return '';
              }

              if (numericValue < 0) {
                return `(-$${Math.abs(numericValue).toFixed(2)})`;
              } else if (numericValue > 0) {
                return `$${numericValue.toFixed(2)}`;
              }

              return `$${numericValue.toFixed(2)}`;
            }
          };
        }

        if (colDef.cellClass === 'currency-value-negative') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              const stringValue = params?.value?.toString();
              const numericValue = parseFloat(stringValue?.replace(/[^\d.-]/g, ''));

              if (numericValue < 0) {
                return 'negative-dollar';
              }

              return '';
            },
            valueFormatter: (params: any) => {
              const stringValue = params?.value?.toString();
              const numericValue = parseFloat(stringValue?.replace(/[^\d.-]/g, ''));

              if (isNaN(numericValue)) {
                return '';
              }

              if (numericValue < 0) {
                return `(-$${numericValue.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 2 })})`;
              }

              return `$${numericValue.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 2 })}`;
            }
          };
        }

        if (colDef.cellClass === 'numeric-value') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              const stringValue = params?.value?.toString();
              const numericValue = parseFloat(stringValue?.replace(/[^\d.-]/g, ''));

              if (numericValue < 0) {
                return 'negative-dollar';
              } else if (numericValue > 0) {
                return 'positive-dollar';
              }

              return '';
            },
            valueFormatter: (params: any) => {
              const stringValue = params?.value?.toString();
              const numericValue = parseFloat(stringValue?.replace(/[^\d.-]/g, ''));

              if (isNaN(numericValue)) {
                return '';
              }

              if (numericValue < 0) {
                return `(${numericValue})`;
              } else if (numericValue > 0) {
                return `${numericValue}`;
              }

              return `${numericValue}`;
            }
          };
        }

        if (colDef.field === 'debitCreditIndicatorDesc') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              if (params.value === '(-)') {
                return 'negative-credit';
              } else if (params.value === '(+)') {
                return 'positive-credit';
              }
              return '';
            },
            cellRenderer: (params: any) => {
              if (params.value === '(-)') {
                return `<span class="negative-credit">( - )</span>`;
              } else if (params.value === '(+)') {
                return `<span class="positive-credit">( + )</span>`;
              }
              return params.value;
            }
          };
        }

        if (colDef.cellClass === 'eye') {
          return {
            ...colDef,
            cellRenderer: (params: any) => {
              if (params.value === undefined || params.value === null || params.value === '') {
                return '';
              } else if (params.value === 'Total') {
                return params.value;
              } else {
                return `<div class="eye-cell"><span>${params.value}</span><i class="fa-solid fa-eye eye-ag-grid"></i></div>`;
              }
            }
          };
        }

        if (colDef.cellClass === 'caret-value') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              const numericValue = parseFloat(params?.value?.toString()?.replace(/[^\d.-]/g, ''));

              if (numericValue < 0) {
                return 'negative-value';
              } else if (numericValue > 0) {
                return 'positive-value';
              }

              return '';
            },
            cellRenderer: (params: any) => {
              const numericValue = parseFloat(params?.value?.toString()?.replace(/[^\d.-]/g, ''));

              if (isNaN(numericValue)) {
                return '';
              }

              const percentageValue = numericValue.toFixed(2) + '%';

              if (numericValue < 0) {
                return `(${percentageValue}) <span class="caret-down"></span>`;
              } else if (numericValue > 0) {
                return `${percentageValue} <span class="caret-up"></span>`;
              }

              return percentageValue;
            }
          };
        }

        if (colDef.cellClass === 'truck') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              if (params.value) {
                if (params?.value.toLowerCase() === 'delivered') {
                  return 'green-del-text';
                } else if (params?.value.toLowerCase() === 'in transit') {
                  return 'truck-tran-text';
                } else if (params?.value.toLowerCase() === 'picked up') {
                  return 'truck-pick-text';
                } else if (params?.value.toLowerCase() === 'not found') {
                  return 'truck-nfound-text';
                } else {
                  return '';
                }
              } else {
                return null;
              }
            },
            cellRenderer: (params: any) => {
              if (params.value)
                if (params?.value.toLowerCase() === 'delivered') {
                  return `<span class="truck-del"></span> ${params?.value}`;
                } else if (params?.value.toLowerCase() === 'in transit') {
                  return `<span class="truck-transit"></span> ${params?.value}`;
                } else if (params?.value.toLowerCase() === 'picked up') {
                  return `<span class="truck-pick"></span> ${params?.value}`;
                } else if (params?.value.toLowerCase() === 'not found') {
                  return `<span class="truck-nfound"></span> ${params?.value}`;
                } else {
                  return `<span class="truck-del"></span> ${params?.value}`;
                }
              else {
                return null;
              }
            }
          };
        }

        if (colDef.cellClass === 'actions-setup') {
          return {
            ...colDef,
            floatingFilter: false,
            cellRenderer: ActionsRequestSetupComponent
          };
        }

        if (colDef.cellClass === 'flow') {
          return {
            ...colDef,
            cellRenderer: (params: any) => {
              if (params.value !== undefined && params?.value !== null) {
                const value = params?.value;
                const [part1, part2, part3] = value?.split(' - ');
                const [part2a, rest] = part2?.split(' : ');

                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.alignItems = 'baseline';

                const span1 = document.createElement('span');
                span1.style.backgroundColor = 'rgb(151, 214, 255)';
                span1.style.borderRadius = '50%';
                span1.style.display = 'inline-block';
                span1.style.marginTop = '4px';
                span1.style.width = '2.2em';
                span1.style.height = '2.2em';
                span1.style.lineHeight = '23px';
                span1.style.color = 'var(--title-cards, #114868)';
                span1.style.textAlign = 'center';
                span1.style.fontFamily = 'Montserrat';
                span1.style.fontSize = '11px';
                span1.style.fontStyle = 'normal';
                span1.style.fontWeight = '700';
                span1.style.textTransform = 'uppercase';
                span1.textContent = part1;

                const span2 = document.createElement('span');
                span2.style.marginLeft = '5px';
                span2.style.fontSize = '11px';
                span2.textContent = part2a + ' : ';

                const span3 = document.createElement('span');
                span3.style.marginLeft = '5px';
                span3.style.borderBottom = '2px dotted #0071bc';
                span3.style.color = '#0072BC';
                span3.style.height = '23px';
                span3.style.fontSize = '11px';
                span3.textContent = ` ${rest}`;

                const span4 = document.createElement('span');
                span4.style.height = '23px';
                span4.style.fontSize = '11px';
                span4.textContent = ` - `;

                const span5 = document.createElement('span');
                span5.style.marginLeft = '5px';
                span5.style.borderBottom = '2px dotted #0071bc';
                span5.style.color = '#0072BC';
                span5.style.height = '23px';
                span5.style.fontSize = '11px';
                span5.textContent = `${part3}`;

                container.appendChild(span1);
                container.appendChild(span2);
                container.appendChild(span3);
                container.appendChild(span4);
                container.appendChild(span5);

                return container;
              }
              return params.value;
            }
          };
        }

        //invt. Amd
        if (colDef.field === 'inventoryValueUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //Billing Backlog
        if (colDef.field === 'billingBacklog') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //PURCHASE INFORMATIONS - PO Net Price
        if (colDef.field === 'poNetOrderPriceUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //PURCHASE INFORMATIONS - PO Acc Net Price
        if (colDef.field === 'poAccountedNetPriceUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //PURCHASE INFORMATIONS - GR Value
        if (colDef.field === 'goodsReceiptValueUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //PURCHASE INFORMATIONS - PO Acc Net Value
        if (colDef.field === 'poAccountedNetValueUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //PURCHASE INFORMATIONS - Backlog Value
        if (colDef.field === 'outstandingValueUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //PURCHASE INFORMATION - VIEW DETAILS - SO Item Net Amt
        if (colDef.field === 'lineTotalNetValueUsd') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //billingCancelCmGrossAmt
        if (colDef.field === 'billingCancelCmGrossAmt') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        //Bill Open Tax Amt
        if (colDef.field === 'billingOpenTaxAmt') {
          return {
            ...colDef,
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.cellClass === 'line-dotted') {
          return {
            ...colDef,
            cellRenderer: (params: any) => {
              if (params.value !== undefined && params?.value !== null) {
                const container = document.createElement('div');
                const span = document.createElement('span');
                span.style.marginLeft = '5px';
                span.style.borderBottom = '2px dotted #0071bc';
                span.style.color = '#0072BC';
                span.style.height = '23px';
                span.style.fontSize = '11px';
                span.textContent = ` ${params?.value}`;

                container.appendChild(span);

                return container;
              }
              return params.value;
            }
          };
        }

        if (colDef.cellClass === 'flow-desc') {
          return {
            ...colDef,
            cellRenderer: (params: any) => {
              if (params.value !== undefined && params?.value !== null) {
                const value = params?.value;
                const [part1, part2] = value?.split(' - ');

                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.alignItems = 'baseline';

                const span1 = document.createElement('span');
                span1.style.backgroundColor = '#e7e7e7';
                span1.style.borderRadius = '50%';
                span1.style.display = 'inline-block';
                span1.style.marginTop = '4px';
                span1.style.width = '2.2em';
                span1.style.height = '2.2em';
                span1.style.lineHeight = '23px';
                span1.style.color = 'var(--title-cards, #313639)';
                span1.style.textAlign = 'center';
                span1.style.fontFamily = 'Montserrat';
                span1.style.fontSize = '11px';
                span1.style.fontStyle = 'normal';
                span1.style.fontWeight = '700';
                span1.style.textTransform = 'uppercase';
                span1.textContent = part1;

                const span2 = document.createElement('span');
                span2.style.marginLeft = '5px';
                span2.style.fontSize = '11px';
                span2.textContent = part2;

                container.appendChild(span1);
                container.appendChild(span2);

                return container;
              }
              return params.value;
            }
          };
        }

        if (colDef.cellClass === 'am-associated') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              if (params.value) {
                return 'am-text';
              } else {
                return null;
              }
            },
            cellRenderer: (params: any) => {
              if (params.value === undefined || params.value === null || params.value === '') {
                return '';
              } else if (params.value === 'Total') {
                return params.value;
              } else if (params.value > 0) {
                return `<div class="eye-cell"><i class="fa-solid fa-eye eye-ag-grid-am"></i><span> ( ${params.value} )</span></div>`;
              } else if (params.value == 0) {
                return `<div class="eye-cell"><i class="fa-solid fa-circle-plus add-team-am"></i><span class="text-add-am"> add ${colDef.headerName.toLowerCase()}  </span></div>`;
              }
            }
          };
        }

        if (colDef.field === 'roleName') {
          return {
            ...colDef,
            cellClass: () => {
              return 'role-name';
            },
            cellRenderer: (params: any) => {
              var txt = params.value;
              if (txt) {
                var str = txt.split('_');
                return str.join(' ');
              } else {
                return params.value;
              }
            }
          };
        }

        if (colDef.field === 'statusFlag') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              if (params.value === 'Activated') {
                return '';
              } else if (params.value === 'Inactivated') {
                return '';
              }
              return '';
            },
            cellRenderer: (params: any) => {
              if (params.value === 'Activated') {
                return `<span class="badge bg-activated">${params.value}</span>`;
              } else if (params.value === 'Inactivated') {
                return `<span class="badge bg-inactivated">${params.value}</span>`;
              }
              return params.value;
            }
          };
        }

        if (colDef.field === 'status') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              if (params.value === 'In Progress') {
                return '';
              } else if (params.value === 'Pending') {
                return '';
              } else if (params.value === 'Awaiting') {
                return '';
              } else if (params.value === 'Setup conf') {
                return '';
              } else if (params.value === 'Cancelled') {
                return '';
              } else if (params.value === 'Homologed') {
                return '';
              } else if (params.value === 'Draft') {
                return '';
              }
              return '';
            },
            cellRenderer: (params: any) => {
              if (params.value === 'In Progress') {
                return `<span class="badge bg-progress">IN PROGRESS</span>`;
              } else if (params.value === 'Pending') {
                return `<span class="badge bg-pending">PENDING</span>`;
              } else if (params.value === 'Awaiting') {
                return `<span class="badge bg-awaiting">AWAITING</span>`;
              } else if (params.value === 'Setup conf') {
                return `<span class="badge bg-setup">SETUP CONF</span>`;
              } else if (params.value === 'Cancelled') {
                return `<span class="badge bg-canceled">CANCELLED</span>`;
              } else if (params.value === 'Homologed') {
                return `<span class="badge bg-homologed">HOMOLOGED</span>`;
              } else if (params.value === 'Draft') {
                return `<span class="badge bg-draft">DRAFT</span>`;
              }
              return params.value;
            }
          };
        }

        if (colDef.field === 'contactPhone') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              // Correção: cellClass em vez de cellCalss
              if (params.value === undefined || params.value === null || params.value === '') {
                return '';
              } else {
                return '';
              }
            },
            cellRenderer: (params: any) => {
              if (params.value) {
                return `<div ><i class="icon-phone"></i>${params.value}</div>`;
              }
              return params.value;
            }
          };
        }

        if (colDef.field === 'contactEmail') {
          return {
            ...colDef,
            cellClass: (params: any) => {
              if (params.value === undefined || params.value === null || params.value === '') {
                return '';
              } else {
                return '';
              }
            },
            cellRenderer: (params: any) => {
              if (params.value) {
                return `<div ><i class="icon-mail"></i>${params.value}</div>`;
              }
              return params.value;
            }
          };
        }

        if (colDef.field === 'buyer') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-count';
            },
            cellRenderer: FilterTheClickTableComponent
          };
        }

        if (colDef.field === 'pocOunt') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-count';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === 'poLineCount') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-line-count';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === 'poItemTotalAmtUsd') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-item-total-amt-usd';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === 'backlogAmt') {
          return {
            ...colDef,
            cellClass: () => {
              return 'backlog-amt';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === 'avgpoBacklogDays') {
          return {
            ...colDef,
            cellClass: () => {
              return 'avg-po-backlog-days';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === 'poCountPerf') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-count-perf';
            },
            cellRenderer: PercentCellRendererComponent
          };
        }

        if (colDef.field === 'poLineCountPerc') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-line-count-perc';
            },
            cellRenderer: PercentCellRendererComponent
          };
        }

        if (colDef.field === 'poAmtPerf') {
          return {
            ...colDef,
            cellClass: () => {
              return 'po-amt-perf';
            },
            cellRenderer: PercentCellRendererComponent
          };
        }

        if (colDef.field === '2018' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2018';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2018' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2018';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2018') {
          return {
            ...colDef,
            cellClass: () => {
              return '2018';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2019' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2019';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2019' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2019';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2019') {
          return {
            ...colDef,
            cellClass: () => {
              return '2019';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2020' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2020';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2020' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2020';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2020') {
          return {
            ...colDef,
            cellClass: () => {
              return '2020';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2021' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2021';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2021' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2021';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2021') {
          return {
            ...colDef,
            cellClass: () => {
              return '2021';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2022' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2022';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2022' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2022';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2022') {
          return {
            ...colDef,
            cellClass: () => {
              return '2022';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2023' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2023';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2023' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2023';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2023') {
          return {
            ...colDef,
            cellClass: () => {
              return '2023';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2024' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2024';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2024' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2024';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2024') {
          return {
            ...colDef,
            cellClass: () => {
              return '2024';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2025' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2025';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2025' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2025';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2025') {
          return {
            ...colDef,
            cellClass: () => {
              return '2025';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2026' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2026';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2026' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2026';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2026') {
          return {
            ...colDef,
            cellClass: () => {
              return '2026';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2027' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2027';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2027' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2027';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2027') {
          return {
            ...colDef,
            cellClass: () => {
              return '2027';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2028' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2028';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2028' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2028';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2028') {
          return {
            ...colDef,
            cellClass: () => {
              return '2028';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2029' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2029';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2029' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2029';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2029') {
          return {
            ...colDef,
            cellClass: () => {
              return '2029';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === '2030' && colDef.typeColumn === 'header') {
          return {
            ...colDef,
            cellClass: () => {
              return '2030';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2030' && colDef.typeColumn === 'lines') {
          return {
            ...colDef,
            cellClass: () => {
              return '2030';
            },
            cellRenderer: NumbersCellRedererComponent
          };
        }

        if (colDef.field === '2030') {
          return {
            ...colDef,
            cellClass: () => {
              return '2030';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === 'actualYearPercent') {
          return {
            ...colDef,
            cellClass: () => {
              return 'actual-year-percent';
            },
            cellRenderer: PercentCellRendererComponent
          };
        }

        if (colDef.field === 'productClass') {
          return {
            ...colDef,
            width: 110,
            maxWidth: 110,
            cellClass: () => {
              return 'product-class';
            }
          };
        }

        if (colDef.field === 'serviceProductClass') {
          return {
            ...colDef,
            width: 60
          };
        }

        if (colDef.field === 'roomType') {
          return {
            ...colDef,
            width: 80,
            cellClass: () => {
              return 'room-type';
            }
          };
        }

        if (colDef.field === 'materialCode') {
          return {
            ...colDef,
            width: 130,
            cellClass: () => {
              return 'material-code';
            }
          };
        }

        if (colDef.field === 'materialDescription') {
          return {
            ...colDef,
            width: 135,
            cellClass: () => {
              return 'material-description';
            }
          };
        }

        if (colDef.field === 'costAmt' || colDef.field === 'netValueAmt') {
          return {
            ...colDef,
            cellClass: () => {
              return 'costAmt';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === 'orderQuantity') {
          return {
            ...colDef,
            width: 90,
            cellClass: () => {
              return 'order-quantity';
            }
          };
        }

        if (colDef.field === 'soItemStatus') {
          return {
            ...colDef,
            width: 90
          };
        }

        if (colDef.field === 'goodsReceiptQty') {
          return {
            ...colDef,
            width: 50
          };
        }
        if (colDef.field === 'goodsIssueQty') {
          return {
            ...colDef,
            width: 50
          };
        }
        if (colDef.field === 'goodsIssueQty') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'clientPoNumber') {
          return {
            ...colDef,
            cellRenderer: (params: any) => {
              return params.value;
            },
            width: 90
          };
        }
        if (colDef.field === 'salesOrderDate') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'salesDocumentNumber') {
          return {
            ...colDef,
            cellRenderer: (params: any) => {
              return params.value;
            },
            width: 90
          };
        }
        if (colDef.field === 'salesDocumentItemNumber') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'storageLocationCode') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'vendorName') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'poOrderQty') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'purchaseOrderItemNumber') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'referenceDocument') {
          return {
            ...colDef,
            width: 90
          };
        }
        if (colDef.field === 'purchaseOrderItemNumber') {
          return {
            ...colDef,
            width: 90
          };
        }

        if (colDef.field === 'soldToClientName') {
          return {
            ...colDef,
            width: 165,
            cellClass: () => {
              return 'sales-document-itemNumber';
            }
          };
        }

        if (colDef.field === 'totalNetValueItemAmt') {
          return {
            width: 90,
            ...colDef,
            cellClass: () => {
              return 'total-net-value-item-amt';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        if (colDef.field === 'netValueItemAmt') {
          return {
            width: 100,
            maxWidth: 100,
            ...colDef,
            cellClass: () => {
              return 'netValue-item-amt';
            },
            cellRenderer: CurrencyValueCellRedererComponent
          };
        }

        /*         if (colDef.field === 'referenceDocument') {
                  return {
                    width: 100,
                    maxWidth: 100,
                    ...colDef,
                    cellClass: () => {
                      return 'reference-document';
                    },
                    cellRenderer: CurrencyValueCellRedererComponent,
                  };
                } */

        /*         if (colDef.field === 'goodsReceiptQty') {
                  return {
                    width: 100,
                    maxWidth: 100,
                    ...colDef,
                    cellClass: () => {
                      return 'goods-receipt-qty';
                    },
                    cellRenderer: CurrencyValueCellRedererComponent,
                  };
                } */

        /*         if (colDef.field === 'goodsIssueQty') {
                  return {
                    width: 100,
                    maxWidth: 100,
                    ...colDef,
                    cellClass: () => {
                      return 'goods-issue-qty';
                    },
                    cellRenderer: CurrencyValueCellRedererComponent,
                  };
                } */

        /*         if (colDef.field === 'storageLocationCode') {
                  return {
                    width: 100,
                    maxWidth: 100,
                    ...colDef,
                    cellClass: () => {
                      return 'storage-location-code';
                    },
                    cellRenderer: CurrencyValueCellRedererComponent,
                  };
                } */

        return colDef;
      });

      resolve(this.columnDefs);
    });
  }

  /*   autoSizeAll() {
      const allColumnIds: string[] = [];
      this.gridColumnApi.getColumns()!.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    } */

  autoSizeAll() {
    this.gridColumnApi.autoSizeAllColumns();
  }

  // force table auto height
  setAutoHeight() {
    const container = document.querySelectorAll<HTMLElement>('.tableContainer')! as any;

    container.forEach((grid: any) => {
      var table = grid.querySelector('.tableContent');

      const gridHeight = grid.clientHeight;
      const tableHeight = table.clientHeight;

      if (tableHeight > gridHeight) {
        this.gridApi.setDomLayout('normal');
        table!.style.height = gridHeight - 40 + 'px';
      } else {
        this.gridApi?.setDomLayout('autoHeight');
        /* table!.style.height = ''; */
      }
    });
  }

  callModal(params: any) {}

  onCellClicked(event: any) {
    if (event.colDef.field === 'checkbox') {
      const column = event.colDef.field;
      const newValueCheckBox = !event.data.checkbox;
      const data = event.data;

      event.data.checkbox = newValueCheckBox;
      this.gridApi.refreshCells({ rowNodes: [event.node], force: true });
      this.emitEventClick({ column, data });
    }

    if (event.event.target.getAttribute('data-action')) {
      const actions = event.event.target.getAttribute('data-action');
      const data = event.data.actions?.[actions];
      this.emitEventClick({ actions, data });
    }

    if (event?.colDef?.eventClick) {
      const column = event.colDef.field;
      const value = event.value;
      const path = event.colDef.path;
      const modalName = event.colDef.modalName;
      const cellClass = event.colDef.cellClass;
      const get = event.colDef.get;
      this.emitEventClick({ column, value, path, modalName, cellClass, get, event });
    }
  }

  emitEventClick(params: any) {
    this.customCellClick.emit(params);
  }

  idValueFormatter(params: any): string {
    const value = Number(params.value);
    const color = value < 0 ? 'red' : 'green';
    return `<span style="color: ${color};">${value}</span>`;
  }

  onBtnExport() {
    this.gridApi.exportDataAsCsv();
  }

  dateFormatter = (params: any) => {
    if (params.value === undefined || params.value === null) return '';
    return this.formatDate(params.value);
  };

  formatDate(dateStr: string) {
    const date = new Date(dateStr);
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return `${monthNames[monthIndex]} ${day}, ${year}`;
  }

  getTotalCostValueCellStyle(params: any) {
    if (params.value < 0) {
      return 'negative-value';
    }
    return '';
  }

  // Função para abrir o popup
  openPopup() {
    this.showPopup = true;
  }

  // Função para fechar o popup
  closePopup() {
    this.showPopup = false;
  }

  replaceCellRenderer(resp: any, targetRenderer: string, newRenderer: any) {
    for (const def of resp.columnDefs) {
      if (def.cellRenderer === targetRenderer) {
        def.cellRenderer = newRenderer;
      }
    }
  }

  onReplaceRendererButtonClick(resp: any) {
    this.replaceCellRenderer(resp, 'NumbersCellRedererComponent', NumbersCellRedererComponent);
    this.replaceCellRenderer(resp, 'CurrencyValueCellRedererComponent', CurrencyValueCellRedererComponent);
    this.replaceCellRenderer(resp, 'ActionsRequestSetupComponent', ActionsRequestSetupComponent);
  }
}
